import React, { Component } from 'react';
import instance from "./axios-instance";
import MainSettingContext from './MainSettingContext';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import md5 from 'md5';
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: true,
            pagecount: 1,
            username: props.username || null,
            settingwheel: "",
            settingcheckin: "",
            userid: props.userid || null,
            phoneNumber: "",
            balance: props.balance || 0,
            mainacc: null,
            tabselect: 1,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: props.loginstate || false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: props.linelink || "",
            errortext: "",
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: props.maxwithdrawstatus || 0,
            tblprofile: props.tblprofile || [],
            prodetail: [],
            oldpassword: "",
            linkaff: props.linkaff || "",
            webnamex: props.webnamex || "",
            inviteSet: props.inviteSet || "",
            truegiftlink: "",
            changepassword: false,
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: props.limit || null,
            rankpic: props.rankpic || "1.jpeg",
            rankname: props.rankname || null,
            rankob: props.rankob || null,
            cashoutSet: props.cashoutSet || [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }

    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf, checkboxacc, accnumbertxt } = this.state;
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await Swal.fire({
                            title: 'Success!',
                            text: t(this.lang, 'change_password_success'),
                            icon: 'Success',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 201) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'wrong_old_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 203) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'password_error'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 202) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'same_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await Swal.fire({
                            title: 'success!',
                            text: t(this.lang, 'change_password_success'),
                            icon: 'success',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 201) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'wrong_old_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 203) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'password_error'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 202) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'same_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await Swal.fire({
                            title: 'success!',
                            text: t(this.lang, 'change_password_success'),
                            icon: 'success',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 201) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'wrong_old_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 203) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'password_error'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else if (res.data.status === 202) {
                        await Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'same_password'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                });
            }
        }
        else {
            await Swal.fire({
                title: 'error!',
                text: t(this.lang, 'password_mismatch'),
                icon: 'error',
                confirmButtonText: t(this.lang, 'ok')
            })
        }
    }
    checktab(e, index) {
        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else {
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselect: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselect: index,
                    tabselectsec: 0,
                });
            }
        }
    }

    redeemrank = async (e, index) => {
        e.preventDefault();

        if (this.state.buttoncliam) return;

        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: t(this.lang, 'rank_claim_confirm'),
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.setState({ buttoncliam: true });
                    try {
                        await instance.post("/api/v1/userredeemrank", {
                            User_id: Username,
                            rankno: index.no,
                            System: Systems,
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            if (res.data.status === 200) {
                                this.calllisthistory(Username);
                                this.checklogin();
                                await this.rechecklogin(Username, token, true);
                                Swal.fire(t(this.lang, 'process_success'), '', 'success')
                            }
                            else {
                                Swal.fire(t(this.lang, 'action_failed_wait'), '', 'error')
                            }
                        });
                    } finally {
                        this.setState({ buttoncliam: false });
                    }
                }
            })
        }

    }
    onChangexdep = event => {
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };

    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }
    openchangepassword = (e) => {
        e.preventDefault();
        const { changepassword } = this.state
        if (changepassword)
            this.setState({
                changepassword: false
            });
        else
            this.setState({
                changepassword: true
            });

    }

    onChangex = event => {

        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "phoneNumber") {
                document.getElementById("phoneNumberforget").style = "";
                document.getElementById("checkotpforgetphone").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    confirmdeposit = async (e, num) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (token != null) {

        }

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture,
                                counter: 300,
                                tabselectsec: 1,
                                tabselect: 0
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'deposit_limit_prefix') + ' ' + this.state.limit.min + ' ' + t(this.lang, 'baht') + ' ' + t(this.lang, 'deposit_max_label') + ' ' + this.state.limit.max,
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok')
                })
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
        }
        else {
            this.setState({
                depositstate: 0
            });
        }

    }
    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            this.setState({
                userid: decoded.message.playerid,
                username: decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    async rechecklogin(Username, token, forceFresh = false) {

        try {
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            const space = window.location.host
            var userhash = md5(Username);
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js',
                backoffice: forceFresh ? 1 : undefined
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
        }

    }
    async componentDidMount() {
        setInterval(() =>
            this.setState({ counter: this.state.counter - 1 })
        , 1000);

        if (this.props.linelink) {
            this.setState({
                linelink: this.props.linelink,
                maxwithdrawstatus: this.props.maxwithdrawstatus,
                webnamex: this.props.webnamex,
                cashoutSet: this.props.cashoutSet,
                inviteSet: this.props.inviteSet,
                limit: this.props.limit || {},
            });
        } else {
            const data = this.context;
            if (data) {
                const datas = data.message;
                const cat0 = data.tblcatagoryx && data.tblcatagoryx[0];
                const limit = cat0
                    ? { min: cat0.limitdeposit, max: cat0.maxdeposit }
                    : { min: 0, max: 0 };
                this.setState({
                    maxwithdrawstatus: cat0 ? cat0.withdrawmax : 0,
                    linelink: datas && datas[1] ? datas[1].value : '',
                    webnamex: datas && datas[7] ? datas[7].value : '',
                    cashoutSet: data.tblcashoutsetting && data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting && data.tblinvitedsetting[0],
                    datas,
                    limit,
                });
            }
        }

        try {
            var token = localStorage.getItem('auth_token');
            if (this.props.username && token) {
                this.setState({
                    loginstate: this.props.loginstate,
                    username: this.props.username,
                    userid: this.props.userid,
                    balance: this.props.balance,
                    point: this.props.point,
                    rankpic: this.props.rankpic,
                    rankname: this.props.rankname,
                });
                await this.rechecklogin(this.props.username, token);
            } else if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            } else {
                this.setState({ loginstate: false });
            }
            var authToken = localStorage.getItem('auth_token');
            if (authToken != null) {
                var dec = jwt_decode(authToken);
                let Username = dec.message.playerid;
                instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    amount: 50
                }, {
                    headers: { Authorization: `Bearer ${authToken}` }
                }).then(async (res) => {
                    this.setState({ mainacc: res.data.mainacc });
                });
            }
        } catch (error) {}
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loginstate !== this.props.loginstate ||
            prevProps.balance !== this.props.balance ||
            prevProps.point !== this.props.point) {
            if (this.props.loginstate && this.props.username) {
                this.setState({
                    loginstate: this.props.loginstate,
                    username: this.props.username,
                    userid: this.props.userid,
                    balance: this.props.balance,
                    point: this.props.point,
                    tblprofile: this.props.tblprofile,
                    rankpic: this.props.rankpic,
                    rankname: this.props.rankname,
                    rankob: this.props.rankob,
                    rankpoint: this.props.rankpoint,
                    linkaff: this.props.linkaff,
                    linelink: this.props.linelink || this.state.linelink,
                    maxwithdrawstatus: this.props.maxwithdrawstatus || this.state.maxwithdrawstatus,
                    webnamex: this.props.webnamex || this.state.webnamex,
                    cashoutSet: this.props.cashoutSet || this.state.cashoutSet,
                    inviteSet: this.props.inviteSet || this.state.inviteSet,
                    limit: this.props.limit || this.state.limit,
                });
            }
        }
    }
    render() {
        const lang = this.props.language || this.context?.language || 'th';
        const pathname = this.state.pathname
        const { loginstate, userid, changepassword, username, point, accnumber, firstname, rankpoint, mainacc, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        const fmt = (n) => Number(n || 0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        const ranks = this.state.tblrankall || [];
        const nextRank = ranks.find((r) => Number(r.lowamount) > Number(rankpoint));
        const nextTarget = nextRank ? Number(nextRank.lowamount) : Number(rankpoint);
        const progressPct = nextTarget > 0 ? Math.min(100, (Number(rankpoint) / nextTarget) * 100) : 100;
        return (
            <>
                <div className="-games-index-page col-12">
                    <div className="mb-2 text-white-v1">
                        <div className="d-none d-lg-block">
                            <div>
                                <br />
                                <br />
                                <br />
                            </div>
                            {/**/}
                            {/**/}
                            <div>{/**/}</div>
                            {/**/}
                            {/**/}
                        </div>
                        {/**/}
                        <div className="padding-router-view">
                            <div className="container p-0 x-margin-top-v3">
                                <div className="row m-0 border-shadow-title">
                                    <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                        <div className="text-center bg-title-web">
                                            <div>
                                                <div className="text-title text-white-v1 text-center">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="text-white-v1-deposit" href='/'>
                                                            <a role="button">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={25}
                                                                    height={25}
                                                                    fill="currentColor"
                                                                    className="bi bi-arrow-left-circle text-white"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                    />
                                                                </svg>
                                                            </a>
                                                        </div>
                                                        <div className="text-white-v1-deposit">
                                                            <h5>{t(lang, 'account_info')}</h5>
                                                        </div>
                                                        <div>{/**/}</div>
                                                    </div>
                                                    <hr className="mt-0" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="js-profile-account-modal -layout-account">
                                            <div className="x-account-profile -v2">
                                                <div
                                                    data-animatable="fadeInModal"
                                                    className="-profile-container animated fadeInModal"
                                                >
                                                    <div className="bg-profile-box">
                                                        <div className="d-flex justify-content-start align-self-center bg-dark-table p-2">
                                                            <div>
                                                                <div className="d-flex justify-content-start">
                                                                    <div className="align-self-center">
                                                                        <img
                                                                            width={"100px"}
                                                                            className="img-fluid -profile-image"
                                                                            src={"/build/rank/" + this.state.rankpic}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="p-2 align-self-center">
                                                                        <div className="username-profile">
                                                                            <b>
                                                                                {username}
                                                                            </b>
                                                                        </div>
                                                                        <div className="username-profile">
                                                                            <span className="badge text-bg-light">
                                                                                {this.state.rankname || "Bronze"}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="x-admin-contact text-center m-0">
                                                            <a href={() => false} style={{ cursor: "pointer" }}
                                                                onClick={(e) => {
                                                                    this.openchangepassword(e, 'bonusaccount')
                                                                }}
                                                                className="-link-change-password" ><u>{t(lang, 'change_password')}</u></a>
                                                            <div className="x-checkbox-primary">
                                                                <div
                                                                    className={"-change-password-container js-change-password-collapse collapse" + (changepassword ? "d-none" : "")}
                                                                >
                                                                    <div className="js-collapse-content">
                                                                        <div
                                                                            noValidate=""
                                                                            name="sylius_user_change_password"
                                                                            method="post"
                                                                        >
                                                                            <div className="form-group mt-3">
                                                                                <input
                                                                                    onChange={this.onChangex}
                                                                                    type="password"
                                                                                    id="oldpassword"
                                                                                    name="oldpassword"
                                                                                    required="required"
                                                                                    placeholder={t(lang, 'old_password')}
                                                                                    className="x-form-control form-control"
                                                                                />
                                                                            </div>
                                                                            <br></br>
                                                                            <div className="form-group">
                                                                                <input
                                                                                    onChange={this.onChangex}
                                                                                    type="password"
                                                                                    id="password"
                                                                                    name="password"
                                                                                    required="required"
                                                                                    placeholder={t(lang, 'new_password')}
                                                                                    className="x-form-control form-control"
                                                                                />
                                                                            </div>
                                                                            <br></br>
                                                                            <div className="form-group">
                                                                                <input
                                                                                    onChange={this.onChangex}
                                                                                    type="password"
                                                                                    id="passwordcf"
                                                                                    name="passwordcf"
                                                                                    required="required"
                                                                                    placeholder={t(lang, 'confirm_password')}
                                                                                    className="x-form-control form-control"
                                                                                />
                                                                            </div>
                                                                            <a
                                                                                onClick={(e) => {
                                                                                    this.resetpassword(e, 1)
                                                                                }}
                                                                                type="submit"
                                                                                style={{ background: "linear-gradient(180deg, #23e500, #1be305" }}
                                                                                className="text-white js-account-approve-aware btn -btn-deposit"
                                                                            >
                                                                                <span>{t(lang, 'confirm')}</span>
                                                                            </a>
                                                                            <input
                                                                                type="hidden"
                                                                                id="sylius_user_change_password__token"
                                                                                name="sylius_user_change_password[_token]"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                            <span className="x-text-with-link-component">
                                                                <label className="-text-message">{t(lang, 'contact_problem_title')}</label>
                                                                <a
                                                                    role="button"
                                                                    href={this.state.linelink}
                                                                    className="-link-message"
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                >
                                                                    <u>{t(lang, 'contact_support_text')}</u>
                                                                </a>
                                                            </span>
                                                        </div>
                                                        <div className="animated animatedFadeInUp fadeInUp bg-profile-box-overview mb-2">
                                                            <div>
                                                                <div className="text-white-v1 text-center mx-auto my-auto">
                                                                    <div className="p-1 p-sm-1">
                                                                        <div className="flex justify-between mb-1 mx-auto">
                                                                            <div className="sub-content w-100 p-3 credit-bl-text">
                                                                                <div className="text-center">
                                                                                    <img
                                                                                        className="rounded-full w-10 mb-2 flex"
                                                                                        src={accnumber !== null ? accnumberx.img_path : ""}
                                                                                        style={{ width: 38 }}
                                                                                    />{" "}
                                                                                    &nbsp; {accnumber !== null ? accnumberx.fullname_th : ""}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                    {firstname} &nbsp; | &nbsp;  {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                        <div className="pt-2 pb-2">
                                                            <div className="bg-profile-box-overview p-2 mb-2">
                                                                <div className="text-right">
                                                                    <small id="max_deposit">{progressPct.toFixed(0)} %</small>
                                                                </div>
                                                                <div className="pb-0">
                                                                    <div
                                                                        className="progress progress-lv"
                                                                        role="progressbar"
                                                                        aria-label="Example with label"
                                                                        aria-valuenow={Number(rankpoint)}
                                                                        style={{ height: "5px !important" }}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={nextTarget}
                                                                    >
                                                                        <div
                                                                            className="progress-bar"
                                                                            style={{ width: progressPct + "%" }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="align-self-center text-left pt-2">
                                                                        <div role="button">
                                                                            <small className="font-play-text">
                                                                                {t(lang, 'current_deposit')}
                                                                            </small>
                                                                            <div>
                                                                                <b>{fmt(rankpoint)} {t(lang, 'baht')}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right pt-2">
                                                                        <div role="button">
                                                                            <small className="font-play-text">
                                                                                {t(lang, 'need_deposit')}
                                                                            </small>
                                                                            <div>
                                                                                <b>{fmt(nextTarget)} {t(lang, 'baht')}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr className="m-0 color-hr" />
                                                            </div>
                                                            <table className="table table-borderless table-striped">
                                                                <tbody>
                                                                    {this.state.tblrankall.map((listitem, i) => (
                                                                        <tr key={i} id={listitem.no}>
                                                                            <td className="-description-body-wrapper">
                                                                                <img
                                                                                    width={"100px"}
                                                                                    className="img-fluid -profile-image"
                                                                                    src={"/build/rank/" + listitem.image}
                                                                                    alt=""
                                                                                />
                                                                                <div className="-title-wrapper">
                                                                                    <p><span className="-title">{listitem.name}</span>        </p>
                                                                                </div>
                                                                                <div className="-state-wrapper">
                                                                                    <span className="-text-description">{t(lang, 'deposit_limit_prefix') + " " + Number(listitem.lowamount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang, 'deposit_baht_up')} {(listitem.no === 1) ? "" : t(lang, 'bonus_label') + " " + Number(listitem.claimamount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " " + t(lang, 'baht')} </span>
                                                                                </div>
                                                                            </td>
                                                                            <td className="-transaction-body-wrapper">
                                                                                {
                                                                                    (listitem.no === 1) ? "" :
                                                                                        (Number(listitem.lowamount) > Number(rankpoint)) ? t(lang, 'not_qualified') :
                                                                                            (!listitem.checked) ? <div> <img
                                                                                                src="/images/cloudigame/ic_success.png"
                                                                                                className="-ic"
                                                                                                width={"30px"}
                                                                                                alt=""
                                                                                            /><span className="-state-title" style={{ marginLeft: "10px" }}>{t(lang, 'status_approve')}</span></div> :
                                                                                                <a href={() => false}
                                                                                                    style={{ cursor: this.state.buttoncliam ? "not-allowed" : "pointer", opacity: this.state.buttoncliam ? 0.5 : 1, pointerEvents: this.state.buttoncliam ? "none" : "auto" }}
                                                                                                    className="text-white js-account-approve-aware btn -btn-deposit active"
                                                                                                    onClick={(e) => {
                                                                                                        this.redeemrank(e, listitem)
                                                                                                    }}><div className="f-7">{this.state.buttoncliam ? t(lang, 'processing_label') : "Cliam"}</div></a>}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
export default App;
